<template>
  <div class="bg-body d-flex flex-column align-items-stretch flex-center rounded-4 w-md-600px w-100 p-10 auth-layout">
    <div v-if="!loading" class="d-flex flex-column flex-column-fluid px-lg-10">
      <template v-if="step !== 4">
        <div class="text-center mb-11">
          <h1 class="text-dark fw-bolder mb-3">Сброс пароля</h1>
          <div v-if="!this.message">
            <div v-if="step === 0" class="text-gray-500 fw-semibold fs-6 mb-1">Введите Логин</div>
            <div v-if="step === 1 || step === 2" class="text-gray-500 fw-semibold fs-6 mb-1">Код отправлено по номеру <b>{{ this.sendPhone }}</b></div>
            <div v-if="step === 3" class="text-gray-500 fw-semibold fs-6 mb-1">Введите новый пароль</div>
          </div>
          <div class="fw-bold fs-6 text-danger" v-else>{{ this.message }}</div>
        </div>
        <section v-if="this.step <= 2">
          <input-mask-field
              v-model="form.iin"
              id="form.iin"
              name="form.iin"
              :required="true"
              :mb="5"
              mask="############"
              placeholder="ИИН"
              type="text"/>
          <input-mask-field
              v-if="step >= 1"
              v-model="form.code"
              id="form.code"
              name="form_code"
              :required="true"
              :mb="5"
              placeholder="Код"
              mask="####"
              type="text"/>
        </section>
        <section v-else>
          <input-field
              v-model="form.password"
              id="form.password"
              name="form_password"
              :required="true"
              :mb="5"
              :has-error="verify.confirm === 1"
              placeholder="Пароль"
              type="password">
            <div class="password-indicator mt-2">
              <span :class="verify.hasLowerCase ? 'success' : ''" title="Содержать строчные буквы (a-z)"></span>
              <span :class="verify.hasUpperCase ? 'success' : ''" title="Содержать заглавные буквы (A-Z)"></span>
              <span :class="verify.hasInteger   ? 'success' : ''" title="Содержать цифровые значения (0-9)"></span>
              <span :class="verify.hasSymbol    ? 'success' : ''" title="Содержать специальные символы (!@#$%^&*()_+{}[]?”:)"></span>
              <span :class="verify.length       ? 'success' : ''" title="Длина пароля должна составлять не менее 8 символов"></span>
            </div>
          </input-field>
          <input-field
              v-model="form.confirm"
              id="form.confirm"
              name="form_confirm"
              :required="true"
              :mb="5"
              :has-error="verify.confirm === 1"
              placeholder="Подтверждение пароля"
              type="password"/>
          <div class="d-grid mb-4">
            <button class="btn btn-primary" :disabled="!(verify.confirm === 2)" @click="setPassword">
              <span class="indicator-label">Изменить пароль</span>
            </button>
          </div>
        </section>
        <div class="d-grid mb-4">
          <button v-if="step === 0" class="btn btn-primary" :disabled="phoneDisabled" @click="sendCode">
            <span class="indicator-label">Отправить код</span>
          </button>
          <button v-if="step === 1" class="btn btn-warning" :disabled="this.timer !== 0" @click="sendCode">
            <span class="indicator-label">Повторно отправить код <span v-if="this.timer > 0"> через {{ this.timer }} сек.</span></span>
          </button>
          <button v-if="step === 2" class="btn btn-primary" :disabled="phoneDisabled" @click="checkCode">
            <span class="indicator-label">Подтвердить код</span>
          </button>
        </div>
        <div class="mt-3 mb-3">
          <router-link :to="{ name: 'Login' }" class="text-primary opacity-75 d-inline-block d-flex align-items-center w-60px">
            <i class="ki-outline ki-black-left fs-3 text-primary"></i>
            Назад
          </router-link>
        </div>
      </template>
      <template v-else>
        <div class="text-center text-primary mb-5">
          <i class="ki-duotone ki-check-circle text-success d-block mb-3 fs-5x opacity-75">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          Пароль был успешно изменен
        </div>
        <router-link class="btn btn-primary" :to="{ name: 'Index' }">Войти</router-link>
      </template>
    </div>
    <loader-full :text="loadingText" v-else style="min-height: 323px"/>
  </div>
</template>

<script>
// View
import InputMaskField from '@/components/Fields/InputMaskField'
import LoaderFull     from '@/components/Main/LoaderFull'
import InputField     from '@/components/Fields/InputField'
// Other
import ValidatorModule from "@/helpers/Modules/Single/ValidatorModule";
import textHelper      from '@/helpers/TextHelper'
import axios           from 'axios'

export default {
  name: 'ResetPassword',
  components: {InputField, LoaderFull, InputMaskField},
  data() {
    return {
      form: {
        iin:    '',
        code:     '',
        password: '',
        confirm:  ''
      },
      sendPhone: null,
      resetToken: null,
      tess: '',
      loadingText: '',
      message:  '',
      phoneDisabled: true,
      loading:  false,
      step: 0,
      timer: 0,
      interval: null,
      verify: {
        hasLowerCase: false,
        hasUpperCase: false,
        hasInteger: false,
        hasSymbol: false,
        confirm: 0,
        length: false
      }
    }
  },
  mounted() {
    this.$store.dispatch("userRequest", null);
    localStorage.clear()
  },
  methods: {
    countDownTimer () {
      this.interval = setInterval(() => {
        if (this.timer === 0) {
          clearInterval(this.interval)
          this.timer = 0
        } else {
          this.timer = this.timer - 1
        }
      }, 1000)
    },
    sendCode() {
      this.message     = ''
      this.resetToken  = null
      this.loading     = true
      this.loadingText = 'Отправляем код на ваш номер'
      axios.post('/api/reset-password', { iin:this.form.iin  })
          .then(res => {
            if (res.data.result) {
              this.timer = 600
              this.countDownTimer()
              if (res.data.sendPhone) this.sendPhone = res.data.sendPhone
              this.step = 1
            } else {
              this.message = res.data.errors.join(', ')
              this.$notifyError(res.data)
            }
          })
          .catch(err => {
            if (err.response.data.hasOwnProperty('result') && !err.response.data.result) {
              this.message = err.response.data.errors.join(', ')
              this.$notifyError(err.response.data)
            } else {
              this.message = err.message
            }
          })
          .finally(() => {
            this.loading     = false
            this.loadingText = ''
          })
    },
    checkCode() {
      this.loading     = true
      this.loadingText = 'Проверяем код подтверждение'
      axios.post('/api/check-code', { iin:this.form.iin, code:this.form.code, type:0 })
          .then(res => {
            if (res.data.result) {
              this.resetToken = res.data.resetToken
              this.step = 3
            } else {
              this.form.code = ''
              this.message   = res.data.message
            }
          })
          .catch(err => {
            this.message = err.message
          })
          .finally(() => {
            this.loading     = false
            this.loadingText = ''
          })
    },
    setPassword() {
      this.loading = true
      this.loadingText = 'Идет проверка аккаунта и пароля'
      axios.post('/api/set-password', { form: { ...this.form, resetToken: this.resetToken } })
          .then(res => {
            if (res.data.result) {
              this.step    = 4
            } else {
              this.step    = 3
              this.message = res.data.message
              this.$notifyError(res.data)
            }
          })
          .catch(err => {
            this.message = err.message
            this.$notifyError(err)
          })
          .finally(() => {
            this.loading     = false
            this.loadingText = ''
          })
    }
  },
  watch:{
    'form.iin': {
      deep: true,
      handler: function(newValue) {
        this.phoneDisabled = newValue.length < 12
        if (this.message && newValue.length < 12) this.message = ''
      },
    },
    'form.code': {
      deep: true,
      handler: function(newValue) {
        if (newValue.length) this.message = ''
        this.step = newValue.length === 4 ? 2 : 1
      },
    },
    'form.password': {
      deep: true,
      handler(newValue) {
        this.verify.hasLowerCase = newValue ? textHelper.hasLowerCase(newValue) : false
        this.verify.hasUpperCase = newValue ? textHelper.hasUpperCase(newValue) : false
        this.verify.hasInteger   = newValue ? textHelper.hasInteger(newValue)   : false
        this.verify.hasSymbol    = newValue ? textHelper.hasSymbol(newValue)    : false
        this.verify.length       = newValue ? newValue.length >= 8              : false
      }
    },
    form: {
      deep: true,
      handler(newValue) {
        if (newValue.password.length > 1 && newValue.confirm.length > 1) {
          let temp = structuredClone(this.verify)
          delete temp['confirm']
          this.verify.confirm = (newValue.password === newValue.confirm && ValidatorModule.simple(temp)) ? 2 : 1
        } else this.verify.confirm = 0
      }
    }
  }
}
</script>

<style></style>